import { useParams } from 'react-router';

import { MLSDataSheetParams } from '../types.ts';

export function useMlsDataSheetParams(): MLSDataSheetParams {
  const openPopup = window.open;
  const { orderId: orderID } = useParams();
  return { openPopup, orderID };
}
